

// material-ui
import { Stack, Typography } from '@mui/material';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
    <Typography variant="caption">&copy; <a href='https://www.sapphiresolutions.net/' target='_blank' style={{
      textDecoration: 'none', 
      color: 'inherit'
    }}>Sapphire Software Solutions</a></Typography>
    <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">

    </Stack>
  </Stack>
);

export default Footer;
